(function () {
  function initOtherSlider(section) {
    var $section = jQuery(section);
    var $track = $section.find('[data-other-slider-track]');
    var prevBtn = section.querySelector('[data-other-slider-prev]');
    var nextBtn = section.querySelector('[data-other-slider-next]');

    if ($track.length === 0 || $track.hasClass('slick-initialized')) {
      return;
    }

    var slickOptions = {
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      speed: 400,
      arrows: true,
      dots: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1199,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 767,
          settings: { slidesToShow: 2 }
        },
        {
          breakpoint: 575,
          settings: { slidesToShow: 1 }
        }
      ]
    };

    if (prevBtn) {
      slickOptions.prevArrow = jQuery(prevBtn);
    }
    if (nextBtn) {
      slickOptions.nextArrow = jQuery(nextBtn);
    }

    $track.slick(slickOptions);

    var wrap = section.querySelector('[data-other-slider-wrap]');
    if (wrap) {
      wrap.classList.add('is-loaded');
    }

    $track.find('[data-other-slider-card]').each(function () {
      var card = this;
      var image = card.querySelector('[data-other-slider-image]');
      var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-other-slider-swatch]'));

      swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          swatches.forEach(function (s) {
            var on = s === swatch;
            s.classList.toggle('is-selected', on);
            s.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          var imageUrl = swatch.getAttribute('data-image');
          if (imageUrl && image) {
            image.setAttribute('src', imageUrl);
          }
        });
      });
    });
  }

  function initAllOtherSliders() {
    var sections = document.querySelectorAll('[data-other-slider]');
    sections.forEach(initOtherSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllOtherSliders);
  } else {
    initAllOtherSliders();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sections = event.target.querySelectorAll('[data-other-slider]');
    sections.forEach(initOtherSlider);
  });
})();
